import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import React from "react";
import { Hero } from "./Sections/Hero";
import { About } from "./Sections/About";
import { Portfolio } from "./Sections/Portfolio";
import { Media } from "./Sections/Media";
import { Contact } from "./Sections/Footer";

function App() {
  return (
    <div>
      <Hero />
      <About />
      <Portfolio />
      <Media />
      <Contact />
      <Analytics />
    </div>
  );
}

// eslint-disable-next-line import/no-default-export
export default App;
